<template>
  <div class="user-button-delete" @click="remove">
    ユーザーを削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('user/deleteUser')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-button-delete {
  @include button-ol-danger;
}
</style>
